<app-loader [isLoading]="isLoading$"></app-loader>
<div class="task-manager-wrapper">
  <div class="flex justify-between header">
    <h2 color="primary">History</h2>
    <button mat-icon-button aria-label="Chiudi" matTooltip="Chiudi" (click)="closeDialog()">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
  <app-dialog-header [praticaCode]="data?.praticaCode" [denominazione]="data?.denomination"></app-dialog-header>

  <mat-dialog-content class="mat-elevation-z2 double-header-dialog-content">
    <mat-tab-group [(selectedIndex)]="selectedTabIndex">
      <mat-tab label="Cronologia">
        <div style="margin: 1rem;">
          <app-history-event *ngFor="let item of dataSource?.data; index as i" [historyEvent]="item" [index]="i"
            [length]="dataSource.data.length">
          </app-history-event>

        </div>

        <mat-paginator #paginator [pageSizeOptions]="pageSizes" [length]="totalData" showFirstLastButtons>
        </mat-paginator>
      </mat-tab>
      <mat-tab label="Azioni">
        <div class="spacing">
          <div class="flex flex-wrap" style="margin-bottom: 2rem;">
            <div *ngFor="let option of taskFieldOptions; index as i" class="task-button-container">
              <button mat-icon-button class="task-button accent-border" color="accent"
                [ngClass]="{'selected accent-bg': option.value === taskFormControl.value}" (click)="setAction(option)"
                [attr.ariaLabel]="option.view">
                <mat-icon [svgIcon]="option.icon" style="margin-right: 2px">
                </mat-icon>
              </button>
              <div class="small" style="margin-top: 0.7rem;">{{option.view | lowercase}}</div>
            </div>
          </div>
          <h2>{{taskFormTitle | lowercase}}</h2>
          <smart-form #dependencyFormComponent [fields]="dependencyFields"></smart-form>
        </div>

      </mat-tab>
    </mat-tab-group>






  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <button *ngFor="let a of actions" mat-flat-button color="accent" [disabled]="!formIsValid" style="margin: 0 0.5rem;"
      (click)="executeTask(a)">
      {{taskField ? 'Conferma' : (a.name | label)}}
    </button>
  </mat-dialog-actions>
</div>